/* ZH-BUILD-OCT4: sticky add-to-cart bar on phones.
   Markup and parameters: snippets/zh-sticky-atc.liquid. Styles: assets/zh-sticky-atc.css.
   The bar never adds to cart itself. Its button clicks the page's own Add to Cart,
   so everything the page does on that click (Subscribe & Save, the free-hat add-on,
   bundles, the cart drawer) still happens. */
(function () {
  'use strict';
  if (window.__zhSatcLoaded) { return; }
  window.__zhSatcLoaded = true;

  var PHONE = window.matchMedia ? window.matchMedia('(max-width: 749px)') : null;

  function clean(s) { return String(s || '').replace(/\s+/g, ' ').trim(); }

  function shown(el) { return !!(el && (el.offsetWidth || el.offsetHeight || el.getClientRects().length)); }

  function firstShown(root, list) {
    if (!list) { return null; }
    var sels = list.split(',');
    for (var i = 0; i < sels.length; i++) {
      var sel = sels[i].trim();
      if (!sel) { continue; }
      var found;
      try { found = root.querySelectorAll(sel); } catch (e) { continue; }
      for (var j = 0; j < found.length; j++) {
        if (shown(found[j])) { return found[j]; }
      }
    }
    return null;
  }

  function initBar(bar) {
    if (bar.__zhSatc) { return; }
    bar.__zhSatc = true;
    if (!('IntersectionObserver' in window)) { return; }

    var sid = bar.getAttribute('data-section') || '';
    var root = document.getElementById('shopify-section-' + sid) || document;
    var atcSel = bar.getAttribute('data-atc') || 'form[action*="/cart/add"] button[type="submit"][name="add"]';
    var priceSel = bar.getAttribute('data-price') || '';
    var optSel = bar.getAttribute('data-option') || '';
    var btn = bar.querySelector('[data-zh-satc-btn]');
    var priceEl = bar.querySelector('[data-zh-satc-price]');
    var optEl = bar.querySelector('[data-zh-satc-opt]');
    var variants = {};
    try { variants = JSON.parse(bar.querySelector('[data-zh-satc-variants]').textContent) || {}; } catch (e) { variants = {}; }

    function findMain() {
      var list;
      try { list = root.querySelectorAll(atcSel); } catch (e) { return null; }
      for (var i = 0; i < list.length; i++) {
        if (!bar.contains(list[i])) { return list[i]; }
      }
      return null;
    }

    var main = findMain();
    if (!main) { return; }

    /* Live at the end of <body>, so no ancestor transform or stacking context traps the fixed bar. */
    document.body.appendChild(bar);

    var past = false;
    var io = new IntersectionObserver(function (entries) {
      var e = entries[entries.length - 1];
      if (e.target !== main) { return; }
      past = !e.isIntersecting && e.boundingClientRect.bottom < 0;
      update();
    });
    var mo = new MutationObserver(function () { update(); });

    function watch(el) {
      io.observe(el);
      mo.observe(el, { attributes: true, attributeFilter: ['disabled'], childList: true, subtree: true, characterData: true });
    }
    function ensureMain() {
      var cur = findMain();
      if (cur && cur !== main) {
        io.unobserve(main);
        mo.disconnect();
        main = cur;
        watch(main);
      }
      return main;
    }

    function form() {
      if (main.form) { return main.form; }
      return main.closest ? main.closest('form') : null;
    }
    function variantId() {
      var f = form();
      var input = f ? f.querySelector('input[name="id"]') : null;
      return input ? String(input.value) : '';
    }
    function soldOut() {
      var v = variants[variantId()];
      return v ? !v.a : false;
    }

    function refresh() {
      var v = variants[variantId()];
      var parts = [];
      if (v && v.t) { parts.push(v.t); }
      var o = firstShown(root, optSel);
      if (o) {
        var ot = clean(o.textContent);
        if (ot) { parts.push(ot); }
      }
      optEl.textContent = parts.join(' · ');
      if (parts.length) { optEl.removeAttribute('hidden'); } else { optEl.setAttribute('hidden', ''); }

      var p = firstShown(root, priceSel);
      var pt = p ? clean(p.textContent) : '';
      if (!pt && v && v.p) { pt = v.p; }
      if (pt) { priceEl.textContent = pt; }

      var lbl = clean((main.querySelector('.btn__text') || main).textContent);
      if (lbl) { btn.textContent = lbl; }
      btn.disabled = !!main.disabled;
    }

    function update() {
      var on = past && (!PHONE || PHONE.matches) && !soldOut();
      if (on) { refresh(); }
      var isOn = !bar.hasAttribute('hidden');
      if (on === isOn) { return; }
      if (on) {
        bar.removeAttribute('hidden');
        document.documentElement.classList.add('zh-satc-on');
        document.documentElement.style.setProperty('--sticky-atc-bar-height', bar.offsetHeight + 'px');
      } else {
        bar.setAttribute('hidden', '');
        document.documentElement.classList.remove('zh-satc-on');
        document.documentElement.style.removeProperty('--sticky-atc-bar-height');
      }
    }

    btn.addEventListener('click', function (ev) {
      ev.preventDefault();
      ensureMain();
      if (!main || main.disabled) { return; }
      main.click();
    });

    function later() { setTimeout(function () { ensureMain(); update(); }, 60); }
    root.addEventListener('change', later);
    root.addEventListener('click', later);
    document.addEventListener('variant:change', later);
    if (PHONE) {
      if (PHONE.addEventListener) { PHONE.addEventListener('change', update); }
      else if (PHONE.addListener) { PHONE.addListener(update); }
    }
    watch(main);
  }

  function boot() {
    var bars = document.querySelectorAll('[data-zh-satc]');
    for (var i = 0; i < bars.length; i++) { initBar(bars[i]); }
  }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', boot); } else { boot(); }
})();